import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder } from '@angular/forms';
import { environment } from 'src/app/environment';
import { ToolsService } from 'src/app/utils/tools.service';
import { BlocksService } from 'src/app/api/report/blocks.service';
import AlertifyHelper from 'src/app/utils/utils';
import SwalAlert from 'src/app/utils/swalalert';
declare var $: any;

@Component({
  selector: 'app-blockshotel-detail',
  templateUrl: './blockshotel-detail.component.html',
  styleUrls: ['./blockshotel-detail.component.css']
})
export class BlockshotelDetailComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // arrays
  book: any = null;
  bookings: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private blocksService: BlocksService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.editData();
  }

  ngOnInit() {
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id = null) {
    this.blocksService.blocksHotelDetail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data;
        this.book = result.book;
        this.bookings = this.book.bookings_data;        
      }
    });
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/cuadreshotel/editar',
      id
    ]);
  }

  delete(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message: ' de cuadre N° ' + item.code,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.blocksService.blocksHotelDelete(item.id, item).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success(
              'El registro de cuadre de hotel ' + item.code + ' se ha eliminado con éxito'
            );
            this.cancel();
          }
        });
      }
    });
  }

  isDebt() {
    let options = {
      title: '¿Estás segur@?',
      message:
        '¿Esta seguro(a) de confirmar la liquidez del cuadre del hotel?. Una vez liquidado ya no se podrá realizar cambios sobre el cuadre realizado',
      cancel: 'Cancelar',
      confirm: 'CONFIRMAR LIQUIDEZ'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
       console.log("here");
       this.blocksService.blocksHotelisDebt(this.book.id, this.book).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success("CONFIRMACIÓN DE LIQUIDEZ realizado con éxito !");
          this.editData(data.data.id);
        }
      });
      }
    });
  }

  printer() {
    (<any>$('#body')).printThis({
      importCSS: true
    });
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/cuadreshotel/lista']);
  }

}
